module.exports = require('./helpers/bundle-url').getBundleURL('2CgdX') + "termsofservice_modalimage.69da62b8.png";